import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import * as Chart from 'chart.js';
import 'chartjs-plugin-datalabels';
import * as _ from 'lodash';
import { ModalDetalheGraficoComponent } from '../../modal-components/modal-detalhe-grafico/modal-detalhe-grafico-component';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'chart-bars-component',
    templateUrl: 'chart-bars-component.html',
    styleUrls: ['./chart-bars-component.scss']
})

export class ChartBarsComponent implements OnInit, AfterViewInit {

    @ViewChild('barsChart', { static: false }) barsChart;

    @Input() classCSS: string;

    @Input() tipo: string;
    @Input() titulo: string;
    @Input() isLegend: boolean;
    @Input() isResize: boolean;
    @Input() lista: any[] = [];
    @Input() infoData: any = {};
    @Input() isStacked = true;
    @Input() stepSize = 30;
    @Input() legRotate: any;
    @Input() isDetail: boolean;
    @Input() legBottom: any;

    chart: any;
    legends: any[] = [];

    constructor(private modalCtrl: ModalController) {
    }

    ngOnInit() {
        console.log('ngAfterViewInit -> ChartPieComponent');
    }

    ngAfterViewInit() {
        if (this.tipo === 'vertical') {
            this.createBarsVertical();
        } else if (this.tipo === 'horizontal') {
            this.createBarsHorizontal();
        } else if (this.tipo === 'verticalPercent') {
            this.createBarsChartPercent();
        }
    }

    async openDetalhe() {
        const modal = await this.modalCtrl.create({
            component: ModalDetalheGraficoComponent,
            keyboardClose: true,
            backdropDismiss: false,
            cssClass: 'modal-detalhe-grafico',
            componentProps: {
                chart: this.chart,
                legRotate: this.legRotate,
                isLegend: this.isLegend,
                legBottom: this.legBottom,
                titulo: this.titulo,
                legends: this.legends,
                infoData: this.infoData,
            }
        }
        );

        // modal.onDidDismiss().then((evt: any) => {});
        return await modal.present();
    }

    createBarsHorizontal() {
        if (this.isLegend) {
            for (const leg of this.infoData.datasets) {
                this.legends.push({ label: leg.label, bgColor: leg.backgroundColor });
            }
        }

        this.chart = new Chart(this.barsChart.nativeElement, {
            type: 'horizontalBar',
            data: {
                labels: this.infoData.labels,
                datasets: [{
                    label: 'Homens',
                    backgroundColor: '#5D78FF',
                    data: this.infoData.datasets[1].data.map((item) => (item * -1)),
                    datalabels: {
                        display: false,
                    },
                }, {
                    label: 'Mulheres',
                    backgroundColor: '#FAB822',
                    data: this.infoData.datasets[0].data,
                    datalabels: {
                        display: false,
                    },
                }]
            },
            options: {
                scales: {
                    yAxes: [{
                        stacked: true,
                        ticks: {
                            padding: 15,
                            display: true,
                            reverse: true,
                            beginAtZero: true,
                            fontColor: '#8498AE',
                            fontStyle: 'bold',
                            fontFamily: 'Circular Std',
                            callback(value) {
                                if (value >= 1000000) {
                                    value = (value / 1000000) + 'M';
                                } else if (value >= 1000) {
                                    value = (value / 1000) + 'K';
                                }
                                return value;
                            }
                        },
                        // type: 'linear',
                        gridLines: {
                            display: true,
                            tickMarkLength: 0,
                            color: '#EEF4F9',
                        }
                    }],
                    xAxes: [{
                        type: 'linear',
                        gridLines: {
                            display: true,
                            color: '#EEF4F9',
                        },
                        ticks: {
                            padding: 15,
                            display: true,
                            reverse: false,
                            beginAtZero: true,
                            // stepSize: 30,
                            fontStyle: 'bold',
                            fontColor: '#8498AE',
                            fontFamily: 'Circular Std',
                            callback(value) {
                                const leg = (value < 0) ? value * -1 : value;

                                const n = leg.toString();
                                let r = '';
                                let x = 0;

                                for (let i = n.length; i > 0; i--) {
                                    r += n.substr(i - 1, 1) + (x === 2 && i !== 1 ? '.' : '');
                                    x = x === 2 ? 0 : x + 1;
                                }

                                return r.split('').reverse().join('');
                            }
                        }
                    }]
                },
                animation: {
                    duration: 1,
                    easing: 'easeOutQuart',
                },
                title: {
                    display: false,
                },
                tooltips: {
                    mode: 'index',
                    callbacks: {
                        title: (items, data) => {
                            return items[0].yLabel + ' anos';
                        },

                        label: (item, data) => {
                            const num = data.datasets[item.datasetIndex].data[item.index];
                            // @ts-ignore
                            return data.datasets[item.datasetIndex].label + ': ' + ((num < 0) ? num * -1 : num).toString();
                        }
                    },
                    // intersect: false,
                    // position: 'nearest',
                    backgroundColor: '#000',
                    titleFontSize: 14,
                    titleFontColor: '#FFFFFF',
                    bodyFontColor: '#FFFFFF',
                    bodyFontSize: 13,
                },
                legend: {
                    display: false,
                },
                hover: {
                    mode: 'index',
                    intersect: false
                },
                responsive: true,
                maintainAspectRatio: false,
            }
        });
    }

    createBarsChartPercent() {
        const option = {
            scales: {
                xAxes: [{
                    radius: 0.3,
                    stacked: true,
                    gridLines: {
                        display: true,
                        color: '#EEF4F9',
                    },
                    ticks: {
                        fontColor: '#8498AE',
                        fontStyle: 'bold',
                        fontFamily: 'Circular Std',
                    },
                }],
                yAxes: [{
                    radius: 0.3,
                    stacked: true,
                    type: 'linear',
                    gridLines: {
                        display: true,
                        color: '#EEF4F9',
                    },
                    ticks: {
                        beginAtZero: true,
                        fontColor: '#8498AE',
                        fontFamily: 'Circular Std',
                        reverse: false,
                        stepSize: 25,
                        callback(value) {
                            return value + '%';
                        }
                    },
                }]
            },
            title: {
                display: false,
            },
            legend: {
                display: false,
            },
            tooltips: {
                mode: 'index',
                intersect: false,
                position: 'nearest',
                backgroundColor: '#000',
                titleFontSize: 14,
                titleFontColor: '#FFFFFF',
                bodyFontColor: '#FFFFFF',
                bodyFontSize: 13,
            },
            hover: {
                mode: 'index',
                intersect: false
            },
            animation: {
                duration: 1,
            },
            responsive: true,
            barRoundness: 0.3,
            maintainAspectRatio: false,
        };

        if (this.isLegend) {
            for (const leg of this.infoData.datasets) {
                this.legends.push({ label: leg.label, bgColor: leg.backgroundColor });
            }
        }

        this.barsChart = new Chart(this.barsChart.nativeElement, {
            data: this.infoData,
            type: 'bar',
            curvature: 1,
            // @ts-ignore
            options: option
        });
    }

    createBarsVertical() {
        const option = {
            scales: {
                xAxes: [{
                    radius: 0.3,
                    stacked: this.isStacked,
                    // barThickness: 30,
                    maxBarThickness: 40,
                    // barPercentage: 0.9,
                    // categoryPercentage: 0,
                    ticks: {
                        fontColor: '#8498AE',
                        // fontStyle: 'bold',
                        fontFamily: 'Circular Std',
                    },
                    gridLines: {
                        display: true,
                        // tickMarkLength: 0,
                        color: '#EEF4F9',
                    }
                }],
                yAxes: [{
                    radius: 0.3,
                    stacked: this.isStacked,
                    // barThickness: 30,
                    maxBarThickness: 40,
                    // barPercentage: 0.9,
                    // categoryPercentage: 0,
                    ticks: {
                        beginAtZero: true,
                        // fontStyle: 'bold',
                        fontColor: '#8498AE',
                        fontFamily: 'Circular Std',
                        reverse: false,
                        stepSize: this.stepSize,
                        // max: 120,
                        callback(value) {
                            const n = value.toString();
                            let r = '';
                            let x = 0;

                            for (let i = n.length; i > 0; i--) {
                                r += n.substr(i - 1, 1) + (x === 2 && i !== 1 ? '.' : '');
                                x = x === 2 ? 0 : x + 1;
                            }

                            return r.split('').reverse().join('');
                        }
                    },
                    // type: 'linear',
                    gridLines: {
                        display: true,
                        color: '#EEF4F9',
                    }
                }]
            },
            datasets: {
                datalabels: {
                    display: false,
                }
            },
            title: {
                display: false,
            },
            legend: {
                display: true,
            },
            tooltips: {
                mode: 'index',
                intersect: false,
                position: 'nearest',
                backgroundColor: '#000',
                titleFontSize: 14,
                titleFontColor: '#FFFFFF',
                bodyFontColor: '#FFFFFF',
                bodyFontSize: 13,
            },
            hover: {
                mode: 'index',
                intersect: false
            },
            animation: {
                duration: 1,
                // onProgress() {
                //     const chartInstance = this.chart,
                //         ctx = chartInstance.ctx;
                //
                //     ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, '500', Chart.defaults.global.defaultFontFamily);
                //     ctx.textAlign = 'center';
                //     ctx.textBaseline = 'bottom';
                //
                //     for (let i = 0; i < this.data.datasets.length; i++) {
                //
                //         const dataset = this.data.datasets[i];
                //
                //         const meta = chartInstance.controller.getDatasetMeta(i);
                //         meta.data.forEach((bar, index) => {
                //             ctx.fillText(dataset.data[index], bar._model.x, bar._model.y - (-1));
                //         });
                //     }
                // }
            },
            responsive: true,
            barRoundness: 0.3,
            maintainAspectRatio: false,
        };

        if (!this.isStacked) {
            // @ts-ignore
            option.scales.yAxes.barThickness = 14;
            // @ts-ignore
            option.scales.yAxes.maxBarThickness = 16;
            // @ts-ignore
            option.scales.yAxes.barPercentage = 0.9;
            // @ts-ignore
            option.scales.yAxes.categoryPercentage = 0;
        }

        if (this.isLegend) {
            for (const leg of this.infoData.datasets) {
                this.legends.push({ label: leg.label, bgColor: leg.backgroundColor });
            }
        }

        this.chart = new Chart(this.barsChart.nativeElement, {
            type: 'bar',
            data: this.infoData,
            // @ts-ignore
            options: option,
        });
    }
}
